import { ActionType } from "./../types/store-types";
import { IField } from "./../fields/types";
import { Selected } from "./../fields/types";

export enum ISelectedItems {
    GLOBALS = "GLOBALS",
    SUBMIT_BUTTON = "submit_button",
    SUBMIT_TEXT = "submit_text",
    BACK_BUTTON = "back_button",
    BACK_TEXT = "back_text",
    NEXT_BUTTON = "next_button",
    NEXT_TEXT = "next_text",
    NEXT_ICON = "next_icon",
    BACK_ICON = "back_icon",
    PAGE = "page",
    INPUT = "input",
    PLACEHOLDER = "placeholder",
    DEFAULT_VALUE = "default_text",
    CHOICES = "choices",
    INPUTS_ICONS = "inputs_icons",
    CHOICES_ICONS = "choices_icons",
    LABEL = "label",
    CHECKBOXES = "checkboxes",
    MAP = "MAP",
    CURRENCY = "currency",
    TERMS_LINK = "terms_link",
    TERMS_TEXT = "terms_text",
    SCALE_RATING_CIRCLES = "scale_rating_circles",
    SCALE_RATING_INPUTS = "scale_rating_inputs",
    CHOICES_LABELS = "choices_label",
    SIGNATURE_TABLE = "signature_table",
    APPLY_BUTTON = "promocode_button",
    APPLY_BUTTON_TEXT = "promocode_button_text",
    UPLOAD_TEXT = "upload_text",
    TALBE_LABEL_CELLS = "table_label_cells",
    TABLE_LABEL = "table_label",
    TABLE_CELLS = "table_cells",
    TABEL_CELL_ICON = "table_cell_icon",
    TABLE_CELL_TEXT = "table_cell_text",
}

export const FieldsSelectableItems = [
    ISelectedItems.LABEL,
    ISelectedItems.INPUT,
    ISelectedItems.PLACEHOLDER,
    ISelectedItems.DEFAULT_VALUE,
    ISelectedItems.CHOICES,
    ISelectedItems.LABEL,
    ISelectedItems.CHECKBOXES,
    ISelectedItems.MAP,
    ISelectedItems.CURRENCY,
    ISelectedItems.TERMS_LINK,
    ISelectedItems.TERMS_TEXT,
    ISelectedItems.SCALE_RATING_CIRCLES,
    ISelectedItems.SCALE_RATING_INPUTS,
    ISelectedItems.SIGNATURE_TABLE,
    ISelectedItems.CHOICES_ICONS,
    ISelectedItems.INPUTS_ICONS,
    ISelectedItems.CHOICES_LABELS,
    ISelectedItems.APPLY_BUTTON,
    ISelectedItems.APPLY_BUTTON_TEXT,
    ISelectedItems.UPLOAD_TEXT,
    ISelectedItems.TABLE_LABEL,
    ISelectedItems.TALBE_LABEL_CELLS,
    ISelectedItems.TABLE_CELLS,
    ISelectedItems.TABEL_CELL_ICON,
    ISelectedItems.TABLE_CELL_TEXT,
];

export enum IDesignElements {
    ALIGNMENT = "alignment",
    IS_ITALIC = "isItalic",
    IS_BOLD = "isBold",
    IS_UNDERLINE = "isUnderline",
    IS_STRIKETHROUGH = "isStrikethrough",
    COLOR = "color",
    SIZE = "size",
    LENGTH = "length",
    FAMILY = "family",
    WEIGHT = "weight",
    FILL = "fill.color",
    BORDER_COLOR = "border.color",
    BORDER_SIZE = "border.size",
    BORDER_RADIUS = "border.radius",
    WIDTH_PX = "widthPx",
    WIDTH_PERCENT = "widthPercent",
    WIDTH_MEASUREMENT = "widthMeasurement",

    INPUT_VALUE_ALIGNMENT = "inputValue.alignment",
    INPUT_VALUE_IS_ITALIC = "inputValue.isItalic",
    INPUT_VALUE_IS_BOLD = "inputValue.isBold",
    INPUT_VALUE_IS_UNDERLINE = "inputValue.isUnderline",
    INPUT_VALUE_IS_STRIKETHROUGH = "inputValue.isStrikethrough",
    INPUT_VALUE_COLOR = "inputValue.color",
    INPUT_VALUE_FAMILY = "inputValue.family",
    INPUT_VALUE_SIZE = "inputValue.size",
    INPUT_VALUE_WEIGHT = "inputValue.weight",

    INPUT_FILL_COLOR = "input.fill.color",
    INPUT_WIDTH_PERCENT = "input.widthPercent",
    INPUT_WIDTH_PX = "input.widthPx",
    INPUT_WIDTH_MEASUREMENT = "input.widthMeasurement",
    INPUT_BORDER_RADIUS = "input.border.radius",
    INPUT_BORDER_COLOR = "input.border.color",
    INPUT_BORDER_SIZE = "input.border.size",
    INPUT_HOVER_COLOR = "input.hoverColor",
}

/* - Data Types - */
export type IIsLogicRuleSelected = null | number;

export type IIsSelected = string | Selected.All;

export type IIsLabelSelected = IIsSelected | null;

export type IIsInputSelected = IIsSelected | null;

export type IIsInputValueSelected = null | IField["_id"] | Selected.All;

export type IIsChoicesSelected = null | IIsSelected;

export type IChangeSelctedItemData = {
    item: ISelectedItems | null;
    items: IField["_id"][];
};

/* - State - */

export interface ISelectedState {
    isSelectedBackground: boolean;
    isLabelSeleced: IIsLabelSelected;
    isInputSeleced: IIsInputSelected;
    isInputValueSeleced: IIsInputValueSelected;
    isChoicesSelected: IIsChoicesSelected;

    item: ISelectedItems | null;
    items: IField["_id"][];
}

/* - Action Types - */

export enum SelectedActionTypes {
    CHANGE_BACKGROUND_SELECTED = "SELECTED.CHANGE_BACKGROUND_SELECTED",
    CHANGE_LABEL_SELECTED = "SELECTED.CHANGE_LABEL_SELECTED",
    CHANGE_INPUT_SELECTED = "SELECTED.CHANGE_INPUT_SELECTED",
    CHANGE_INPUT_VALUE_SELECTED = "SELECTED.CHANGE_INPUT_VALUE_SELECTED",
    CHANGE_CHOICES_SELECTED = "SELECTED.CHANGE_CHOICES_SELECTED",

    CHANGE_SELECTED_ITEM = "SELECTED.CHANGE_SELECTED_ITEM",
}

/* - Action Interfaces  - */

export type ChangeBackgroundSelectedActionType = ActionType<SelectedActionTypes.CHANGE_BACKGROUND_SELECTED, boolean>;

export type ChangeLabelSelectedActionType = ActionType<SelectedActionTypes.CHANGE_LABEL_SELECTED, IIsLabelSelected>;

export type ChangeInputSelectedActionType = ActionType<SelectedActionTypes.CHANGE_INPUT_SELECTED, IIsInputSelected>;

export type ChangeInputValueSelectedActionType = ActionType<
    SelectedActionTypes.CHANGE_INPUT_VALUE_SELECTED,
    IIsInputValueSelected
>;

export type ChangeChoicesSelectedActionType = ActionType<
    SelectedActionTypes.CHANGE_CHOICES_SELECTED,
    IIsChoicesSelected
>;

export type ChnageSelectedItemActionType = ActionType<SelectedActionTypes.CHANGE_SELECTED_ITEM, IChangeSelctedItemData>;
